import {
    APIFailureAction,
    APIRequestAction,
    APISuccessAction,
} from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';

///////////////////////////////////////////////////////////////////
// Topic load

export const TOPIC_INFO_FETCH_TRIGGER = 'TOPIC_INFO_FETCH_TRIGGER';
export interface TopicInfoFetchTriggerAction {
    readonly type: typeof TOPIC_INFO_FETCH_TRIGGER;
    readonly topicSlug: string;
}
export const TOPIC_INFO_FETCH_REQUEST = 'TOPIC_INFO_FETCH_REQUEST';
export interface TopicInfoFetchRequestAction extends APIRequestAction {
    readonly type: typeof TOPIC_INFO_FETCH_REQUEST;
    readonly topicSlug: string;
}
export interface TopicInfoFetchNormalizedResponse extends NormalizedResponse {
    readonly result: { topic: number; moderatorsDetails: any; };
}
export const TOPIC_INFO_FETCH_SUCCESS = 'TOPIC_INFO_FETCH_SUCCESS';
export interface TopicInfoFetchSuccessAction extends APISuccessAction<TopicInfoFetchNormalizedResponse> {
    readonly type: typeof TOPIC_INFO_FETCH_SUCCESS;
    readonly topicSlug: string;
}
export const TOPIC_INFO_FETCH_FAILURE = 'TOPIC_INFO_FETCH_FAILURE';
export interface TopicInfoFetchFailureAction extends APIFailureAction {
    readonly type: typeof TOPIC_INFO_FETCH_FAILURE;
    readonly topicSlug: string;
}

export const topicInfoFetchTrigger =
    (topicSlug: string): TopicInfoFetchTriggerAction => ({
        type: TOPIC_INFO_FETCH_TRIGGER, topicSlug,
    });
export const topicInfoFetchApi = {
    request: (topicSlug: string): TopicInfoFetchRequestAction => ({
        type: TOPIC_INFO_FETCH_REQUEST, topicSlug,
    }),
    success: (topicSlug: string, response: TopicInfoFetchNormalizedResponse): TopicInfoFetchSuccessAction => ({
        type: TOPIC_INFO_FETCH_SUCCESS, topicSlug, response,
    }),
    failure: (topicSlug: string, error: any): TopicInfoFetchFailureAction => ({
        type: TOPIC_INFO_FETCH_FAILURE, topicSlug, error,
    }),
};

///////////////////////////////////////////////////////////////////
// Topic remove moderator

export const TOPIC_REMOVE_MODERATOR_TRIGGER = 'TOPIC_REMOVE_MODERATOR_TRIGGER';
export interface TopicRemoveModeratorTriggerAction {
    readonly type: typeof TOPIC_REMOVE_MODERATOR_TRIGGER;
    readonly topicSlug: string;
    readonly username: string;
}
export const TOPIC_REMOVE_MODERATOR_REQUEST = 'TOPIC_REMOVE_MODERATOR_REQUEST';
export interface TopicRemoveModeratorRequestAction extends APIRequestAction {
    readonly type: typeof TOPIC_REMOVE_MODERATOR_REQUEST;
    readonly topicSlug: string;
    readonly username: string;
}
export interface TopicRemoveModeratorNormalizedResponse extends NormalizedResponse {
    readonly result: { topic: number; moderatorsDetails: any; };
}
export const TOPIC_REMOVE_MODERATOR_SUCCESS = 'TOPIC_REMOVE_MODERATOR_SUCCESS';
export interface TopicRemoveModeratorSuccessAction extends APISuccessAction<TopicRemoveModeratorNormalizedResponse> {
    readonly type: typeof TOPIC_REMOVE_MODERATOR_SUCCESS;
    readonly topicSlug: string;
    readonly username: string;
}
export const TOPIC_REMOVE_MODERATOR_FAILURE = 'TOPIC_REMOVE_MODERATOR_FAILURE';
export interface TopicRemoveModeratorFailureAction extends APIFailureAction {
    readonly type: typeof TOPIC_REMOVE_MODERATOR_FAILURE;
    readonly topicSlug: string;
    readonly username: string;
}

export const topicRemoveModeratorTrigger =
    (topicSlug: string, username: string): TopicRemoveModeratorTriggerAction => ({
        type: TOPIC_REMOVE_MODERATOR_TRIGGER, topicSlug, username,
    });
export const topicRemoveModeratorApi = {
    request: (topicSlug: string, username: string): TopicRemoveModeratorRequestAction => ({
        type: TOPIC_REMOVE_MODERATOR_REQUEST, topicSlug, username,
    }),
    success: (topicSlug: string, username: string, response: TopicRemoveModeratorNormalizedResponse): TopicRemoveModeratorSuccessAction => ({
        type: TOPIC_REMOVE_MODERATOR_SUCCESS, topicSlug, username, response,
    }),
    failure: (topicSlug: string, username: string, error: any): TopicRemoveModeratorFailureAction => ({
        type: TOPIC_REMOVE_MODERATOR_FAILURE, topicSlug, username, error,
    }),
};

///////////////////////////////////////////////////////////////////
// Topic invite moderator

export const TOPIC_INVITE_MODERATOR_TRIGGER = 'TOPIC_INVITE_MODERATOR_TRIGGER';
export interface TopicInviteModeratorTriggerAction {
    readonly type: typeof TOPIC_INVITE_MODERATOR_TRIGGER;
    readonly topicSlug: string;
}
export const TOPIC_INVITE_MODERATOR_REQUEST = 'TOPIC_INVITE_MODERATOR_REQUEST';
export interface TopicInviteModeratorRequestAction extends APIRequestAction {
    readonly type: typeof TOPIC_INVITE_MODERATOR_REQUEST;
    readonly topicSlug: string;
    readonly username: string;
}
export interface TopicInviteModeratorNormalizedResponse extends NormalizedResponse {
    readonly result: { topic: number; moderatorsDetails: any; };
}
export const TOPIC_INVITE_MODERATOR_SUCCESS = 'TOPIC_INVITE_MODERATOR_SUCCESS';
export interface TopicInviteModeratorSuccessAction extends APISuccessAction<TopicInviteModeratorNormalizedResponse> {
    readonly type: typeof TOPIC_INVITE_MODERATOR_SUCCESS;
    readonly topicSlug: string;
    readonly username: string;
}
export const TOPIC_INVITE_MODERATOR_FAILURE = 'TOPIC_INVITE_MODERATOR_FAILURE';
export interface TopicInviteModeratorFailureAction extends APIFailureAction {
    readonly type: typeof TOPIC_INVITE_MODERATOR_FAILURE;
    readonly topicSlug: string;
    readonly username: string;
}

export const topicInviteModeratorTrigger =
    (topicSlug: string): TopicInviteModeratorTriggerAction => ({
        type: TOPIC_INVITE_MODERATOR_TRIGGER, topicSlug,
    });
export const topicInviteModeratorApi = {
    request: (topicSlug: string, username: string): TopicInviteModeratorRequestAction => ({
        type: TOPIC_INVITE_MODERATOR_REQUEST, topicSlug, username,
    }),
    success: (topicSlug: string, username: string, response: TopicInviteModeratorNormalizedResponse): TopicInviteModeratorSuccessAction => ({
        type: TOPIC_INVITE_MODERATOR_SUCCESS, topicSlug, username, response,
    }),
    failure: (topicSlug: string, username: string, error: any): TopicInviteModeratorFailureAction => ({
        type: TOPIC_INVITE_MODERATOR_FAILURE, topicSlug, username, error,
    }),
};
